import { render, staticRenderFns } from "./form-location-select.vue?vue&type=template&id=c4af95ba&scoped=true"
import script from "./form-location-select.vue?vue&type=script&setup=true&lang=js"
export * from "./form-location-select.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4af95ba",
  null
  
)

export default component.exports